import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import './adapters/ess-adapter.esm.js';
import './adapters/thirdparty-adapter-factory.esm.js';
import './adapters/thirdparty-adapter.esm.js';
import { GOOGLEMAPS_CATEGORY } from './adapters/google-adapter.esm.js';
import './adapters/mapbox-adapter.esm.js';
import 'tslib';
import { POWERED_BY_GOOGLE_LOGO } from './assets/google-logo.esm.js';
import { POWERED_BY_MAPBOX_LOGO } from './assets/mapbox-logo.esm.js';
import styles from './uitk-typeahead.css';
var getClassNameList = classNames.bind(styles);
var UitkTypeaheadAttribution = function (props) {
  var results = props.results;
  var category;
  var extractCategoryFromTypeaheadResult = function (taResult) {
    var _a;
    return taResult ? (_a = taResult.data) === null || _a === void 0 ? void 0 : _a.category : '';
  };
  var findAttributedCategory = function (taResults) {
    return taResults.find(function (res) {
      return res.data && res.data.category;
    });
  };
  var getCategoryForUnCategorizedResults = function (typeaheadResults) {
    return extractCategoryFromTypeaheadResult(findAttributedCategory(typeaheadResults));
  };
  var getCategoryForCategorizedResults = function (typeaheadResults) {
    var typeaheadDataWithCategory = typeaheadResults.find(function (item) {
      return findAttributedCategory(item.typeaheadResults);
    });
    if (typeof typeaheadDataWithCategory === 'undefined' || !typeaheadDataWithCategory.typeaheadResults) return '';
    return extractCategoryFromTypeaheadResult(typeaheadDataWithCategory.typeaheadResults[0]);
  };
  var filterAttributionResults = function (typeaheadResults) {
    return typeaheadResults.some(function (result) {
      var key = 'category';
      return result.data && result.data[key] && result.data[key] === category;
    });
  };
  var showLogoForCategorizedResults = function (typeaheadResults) {
    return typeaheadResults.some(function (item) {
      return filterAttributionResults(item.typeaheadResults);
    });
  };
  var showLogoForUnCategorizedResults = function (typeaheadResults) {
    return filterAttributionResults(typeaheadResults);
  };
  var showLogo = function (typeaheadResults) {
    // eslint-disable-next-line default-case
    switch (typeaheadResults.type) {
      case 'categorized':
        category = getCategoryForCategorizedResults(typeaheadResults.items);
        return showLogoForCategorizedResults(typeaheadResults.items);
      case 'uncategorized':
        category = getCategoryForUnCategorizedResults(typeaheadResults.items);
        return showLogoForUnCategorizedResults(typeaheadResults.items);
    }
  };
  if (!showLogo(results)) {
    return null;
  }
  switch (category) {
    case GOOGLEMAPS_CATEGORY:
      return React.createElement("div", {
        className: getClassNameList('uitk-typeahead-google-logo')
      }, React.createElement("img", {
        src: POWERED_BY_GOOGLE_LOGO,
        alt: "Powered by Google Logo"
      }));
    case 'MAPBOX':
      return React.createElement("div", {
        className: getClassNameList('uitk-typeahead-google-logo')
      }, "powered by", ' ', React.createElement("svg", {
        viewBox: "0 0 81 20",
        width: "81px",
        height: "20px"
      }, React.createElement("path", {
        d: POWERED_BY_MAPBOX_LOGO
      })));
    default:
      return null;
  }
};
export { UitkTypeaheadAttribution };